
import React from 'react';
import { connect } from 'react-redux';

import { Collapse } from 'reactstrap';

import Navbar from '../../../../../../_components/common/Navbar';
import SideNavBar from '../../../../../../_components/common/SideNavBar'
import AnalysisNavBar from '../../../../../../_components/common/AnalysisNavBar';

import './index.css'
import CircularButtonGroup from '../../../../../../_components/common/CircularButtonGroup';
import ModalComponent from '../../../../../../_components/common/Modal';
import { addShare } from './formData';
import { saveModulePermissionsAction, orgAdminAction, VirtualTeamAction } from '../../../../../../_actions';


import Swal from 'sweetalert2';


import virtualTeamIcon from '../../../../../../images/virtualTeamIcon.png';


class ShareTeam extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            shareModalState: false,
            deleteModalState: false,
            deleteShareDisable: true,
            checkedAllData: false,
            teamName: null,
            member_count: 0,
            teamId: 'null',
            navData: [],
            VirtualTeamSidebarNav: {
                sideNavCatagoryData: [
                    {
                        name: 'Virtual Teams',
                        link: 'my-teams/manage-virtual-teams'
                    },
                    {
                        name: 'Virtual Team Members',
                        link: 'my-teams/virtual-teams/manage-members'
                    },
                    {
                        name: 'Share Virtual Teams',
                        link: 'my-teams/virtual-teams/manage-share'
                    },
                ]
            },
            select_data: [],
            sharedWith: [],
            deletedSharedWith: [],
            sharedLoader: false
        }
    }

    componentDidMount() {
        let pathName = this.props.location.pathname.split('/');
        // pathName[pathName.length - 1] === 'manage-share' &&
        //     this.props.history.replace(`/organisation/${this.props.match.params.id}/my-teams/virtual-teams/manage-share/245`)
        this.props.dispatch(saveModulePermissionsAction.requestModulePermissionsHandler())
        if (this.props.saveModulePermissionsResponse === '' || (+this.props.saveTeamDetailsResponse.orgId !== +this.props.match.params.id)) {
            const fd = {
                "pa_user_email": localStorage.getItem('user_email'),
                "organisation_id": +this.props.match.params.id
            }
            this.props.dispatch(orgAdminAction.getModulePermissionListHandler(fd, () => {
                this.props.dispatch(saveModulePermissionsAction.saveModulePermissionsHandler(this.props.getModulePermissionsListResponse))
                this.props.dispatch(saveModulePermissionsAction.requestModulePermissionsHandler())
            }))
        }
        else {
            this.props.saveModulePermissionsResponse.filter(
                (data, i) => {
                    if (data.module_list__module_name === 'Virtual Teams') {
                        return data
                    }
                }
            ).length === 0 &&
                this.props.history.push(`/organisation/${this.props.match.params.id}/user/dashboard`)
        }

        const temp = []
        if(localStorage.getItem("is_pa_user") == "true") {
            temp.push({
                navName: "Analyze",
                link: `/organisation/${this.props.match.params.id}/user`
            })
        }
        if(localStorage.getItem("is_org_admin") == "true") {
            temp.push({
                navName: "Org Admin Area",
                link: `/organisation/${this.props.match.params.id}/org-admin`
            })
        }
        if(localStorage.getItem("is_success") == "true") {
            temp.push({
                navName: "Super Admin Area",
                link: `/organisation/${this.props.match.params.id}/super-admin`
            })
        }
        this.setState({navData: temp})

        let postObj_teamList = {
            "analytics_org_id":+this.props.match.params.id
        }

        const { dispatch } = this.props;

        this.setState({
            sharedLoader: true
        }, () => {
            dispatch(VirtualTeamAction.virtualListApi(postObj_teamList, (reloaded) => {
                let select_data = []
    
                if(reloaded.data !== undefined) {
                    if(reloaded.data.team !== undefined) {
                        reloaded.data.team.map(val => {
                            let select_obj = {
                                name: val.team_name,
                                id: val.id,
                                member_count: val.member_count
                            }
                            
                            select_data.push(select_obj)
                        })
                    }
                }
    
                if (this.props.match.params.teamid == undefined && select_data.length) {
                    this.props.history.push(`/organisation/${this.props.match.params.id}/my-teams/virtual-teams/manage-share/${select_data[0].id}`)
                }
                
                this.setState({
                    select_data
                }, () => {
                    this.state.select_data.map(
                        (data, i) => {
                            if (+pathName[pathName.length - 1] === data.id) {
                                this.setState({
                                    teamName: data.name,
                                    teamid: pathName[pathName.length - 1],
                                    member_count: data.member_count
                                })
                            }
                        }
                    )
                })
            }))
    
            if(this.props.match.params.teamid) {
                let postObj_sharedWith = {
                    "team_id":+this.props.match.params.teamid
                }
        
                dispatch(VirtualTeamAction.sharedWith(postObj_sharedWith, (sharedWith_data) => {
                    sharedWith_data.data.shared_with.map(val => {
                        val["value"] = false
                    })
                    this.setState({
                        sharedWith: sharedWith_data.data.shared_with,
                        sharedLoader: false
                    })
                }))
            }
        })
    }

    componentDidUpdate(prevProps, prevState) {

        if(prevProps.headPerLoadingResonse !== this.props.headPerLoadingResonse) {
            if(this.props.headPerLoadingResonse !== '') {
                const temp = []
                if(localStorage.getItem("is_pa_user") == "true") {
                    temp.push({
                        navName: "Analyze",
                        link: `/organisation/${this.props.match.params.id}/user`
                    })
                }
                if(localStorage.getItem("is_org_admin") == "true") {
                    temp.push({
                        navName: "Org Admin Area",
                        link: `/organisation/${this.props.match.params.id}/org-admin`
                    })
                }
                if(localStorage.getItem("is_success") == "true") {
                    temp.push({
                        navName: "Super Admin Area",
                        link: `/organisation/${this.props.match.params.id}/super-admin`
                    })
                }
                this.setState({navData: temp})
            }
        }
        
        if(prevState.sharedWith !== this.state.sharedWith){
            let deleteShareDisable = true
            let deletedSharedWith = []
            let checkedAllData = false
            this.state.sharedWith.map(val => {
                if(val.value !== undefined){
                    if(val.value) {
                        deleteShareDisable = false
                        deletedSharedWith.push(val.id)
                        checkedAllData = true
                    }
                }
            })
            
            this.setState({
                deletedSharedWith,
                deleteShareDisable,
                checkedAllData
            })
        }
    }

    toggleEntireShareModal(showModal) {
        this.setState({
            shareModalState: showModal
        })
    }

    actionSelected(data) {
        const {dispatch} = this.props;
        
        let postObj_shareTeam = {
            "organisation":+this.props.match.params.id,
            "team_id" : +this.props.match.params.teamid,
            "email_id":[data.data.email]
        }

        let postObj_sharedWith = {
            "team_id":+this.props.match.params.teamid
        }

        this.setState({
            sharedLoader: true
        }, () => {
            dispatch(VirtualTeamAction.shareTeam(postObj_shareTeam, (shareTeam_data) => {
                let swalHtml = ``
                shareTeam_data.data.message.map(val => {
                    if(val.email !== undefined && val.message !== undefined) {
                        swalHtml = `${swalHtml} <p>${val.email} : ${val.message}</p>`
                    }else if(val.success_message !== undefined) {
                        swalHtml = `${swalHtml} <p>${val.success_message}</p>`
                    }
                })
                Swal({
                    html: swalHtml,
                    type: 'success',
                    confirmButtonColor: '#3085d6',
                    confirmButtonText: 'OK'
                })
                
                dispatch(VirtualTeamAction.sharedWith(postObj_sharedWith, (sharedWith_data) => {
                    sharedWith_data.data.shared_with.map(val => {
                        val["value"] = false
                    })
                    this.setState({
                        sharedLoader: false,
                        sharedWith: sharedWith_data.data.shared_with
                    })
                }))
            }))
        })


    }

    onChangeTeam = (ev) => {
        this.setState({
            teamid: ev.target.value
        }, () => {
            const {dispatch} = this.props;

            let pathName = this.props.location.pathname.split('/');

            this.state.select_data.map(
                (data, i) => {
                    if (+pathName[pathName.length - 1] === data.id) {
                        this.setState({
                            teamName: data.name,
                            teamid: pathName[pathName.length - 1],
                            member_count: data.member_count
                        })
                    }
                }
            )

            let postObj_sharedWith = {
                "team_id":+this.props.match.params.teamid
            }

            this.setState({
                sharedLoader: true
            })

            dispatch(VirtualTeamAction.sharedWith(postObj_sharedWith, (sharedWith_data) => {
                sharedWith_data.data.shared_with.map(val => {
                    val["value"] = false
                })
                
                this.setState({
                    sharedLoader: false,
                    sharedWith: sharedWith_data.data.shared_with
                })
            }))
        })
        // console.log("value changed", ev.target.value)
        this.props.history.push(`/organisation/${this.props.match.params.id}/my-teams/virtual-teams/manage-share/${ev.target.value}`);
    }

    selectShare(e, type, data) {
        if(type === 'all') {
            let sharedWith = [...this.state.sharedWith];
            
            sharedWith.map(val => {
                if(e.target.checked) {
                    val["value"] = true
                }else {
                    val["value"] = false                    
                }
            })
            this.setState({
                sharedWith
            })
        }else {
            let sharedWith = [...this.state.sharedWith];
            
            sharedWith.map(val => {
                if(val.id === data.id) {
                    if(e.target.checked) {
                        val["value"] = true
                    }else {
                        val["value"] = false                    
                    }
                }
            })

            this.setState({
                sharedWith
            })
        }
    }

    onClickDeleteEmailHandler(type, data) {
        if(type === 'Cancel') {
            this.setState({
                deleteModalState: false
            })
        }else {
            this.setState({
                deleteModalState: false
            }, () => {
                let postObj_share_del = {
                    "shared_id":this.state.deletedSharedWith
                }
                const {dispatch} = this.props;
    
                let postObj_sharedWith = {
                    "team_id":+this.props.match.params.teamid
                }
                this.setState({
                    sharedLoader: true,
                }, () => {
                    dispatch(VirtualTeamAction.deleteShared(postObj_share_del, (deletedDataFromApi) => {
                        Swal({
                            html: deletedDataFromApi.data.message,
                            type: 'success',
                            confirmButtonColor: '#3085d6',
                            confirmButtonText: 'OK'
                        })
                        
                        dispatch(VirtualTeamAction.sharedWith(postObj_sharedWith, (sharedWith_data) => {
                            sharedWith_data.data.shared_with.map(val => {
                                val["value"] = false
                            })
                            this.setState({
                                sharedLoader: false,
                                sharedWith: sharedWith_data.data.shared_with
                            })
                        }))
                    }))
                })
            })
        }
    }

    render() {
        const { navData, select_data } = this.state

        addShare.map(
            (data, i) => {
                data.value = '';
                if (data.validation.required === true) {
                    data.valid = false;
                }
            }
        )

        return (
            <div>
                <Navbar navItems={navData} backgroundColor="black" />
                <div className="container-post-nav">
                    <SideNavBar sideNavItems={this.state.VirtualTeamSidebarNav.sideNavCatagoryData} organisationName={localStorage.getItem('orgName')} orgId={this.props.match.params.id} />
                    <div className="">
                        <AnalysisNavBar
                            analyticsData={this.props.saveModulePermissionsResponse}
                            orgId={this.props.match.params.id}
                            analyticsType={'people'} />
                        <div className="d-flex justify-content-start drop-down-container my-3" style={{margin: 'auto', width: 400}}>
                            <h6 className="d-flex justify-content-start align-items-center mb-0 px-2 " style={{flex: 2}}>Manage Share for Team</h6>
                           
                            <select
                                value={this.state.teamid}
                                className="drop-down form-control"
                                onChange={this.onChangeTeam}
                                style={{flex: 1}}
                            >
                                {
                                    select_data.map((val, key) => {
                                        return (
                                            <option key={key} value={val.id} >{val.name}</option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                        {
                            this.state.sharedLoader ?
                                <i className="fa fa-spinner fa-spin w-100 text-center"></i>
                            :
                                <Collapse isOpen={this.state.teamName}>
                                    <div className="pt-3" style={{ margin: '0px auto', textAlign: 'center', minWidth: '800px', fontSize: 14 }}>
                                        <div style={{ width: '550px', display: 'inline-block' }}>
                                            <div >
                                                <div style={{ height: '40px', lineHeight: '40px', color: 'white', textAlign: 'left', paddingLeft: '15px', backgroundColor: '#845C27' }}>
                                                    <span className="font-weight-bold">{this.state.teamName}'s Team </span><small>({this.state.member_count} Members)</small>
                                                </div>
                                            </div>
                                            {
                                                this.state.sharedWith.length !== 0 ?
                                                    <table class="table"  style={{fontSize: 14}}>
                                                        <thead>
                                                            <tr>
                                                                <th >
                                                                    <input type="checkbox" checked={this.state.checkedAllData} onClick={(e) => this.selectShare(e, 'all')} />    
                                                                </th>                                        
                                                                <th>
                                                                    <p className="font-italic mb-0">Email</p>
                                                                </th>
                                                                <th>
                                                                    <p className="font-italic mb-0">Full Name</p>
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                this.state.sharedWith.map(val => {
                                                                    return (
                                                                        <tr key={val.id}>
                                                                            <td>
                                                                                <input type="checkbox" checked={val.value} onClick={(e) => this.selectShare(e, 'single',  val)} />
                                                                            </td>
                                                                            <td >
                                                                                <p className="font-italic mb-0">{val.shared_to_user__email}</p>
                                                                            </td>
                                                                            <td>
                                                                                <p className="font-italic mb-0">{val.shared_to_user__full_name}</p>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                })
                                                            }
                                                        </tbody>
                                                    </table>
                                                    :
                                                    <p class="text-center">You have not shared this team with anybody.</p>
                                            }
                                            <div className="d-flex flex-row flex-wrap justify-content-between align-items-center">
                                                <div className="col-5 d-flex flex-row  align-items-center">
                                                    <CircularButtonGroup buttonGroupData={[{
                                                        img: virtualTeamIcon,
                                                        link: `/organisation/${+this.props.match.params.id}/my-teams/manage-virtual-teams`,
                                                        id: 3,
                                                        name: "Virtual Team",
                                                        tooltip_id: 3
                                                    },]} swotCatagory={this.props.match.params.id} textAlign={'start'} singleButton={false} />
                                                </div>
                                                <div className="col-">

                                                    {
                                                        <React.Fragment>
                                                            <button onClick={() => this.setState({ deleteModalState: true })} style={{ backgroundColor: 'rgb(211, 211, 211)' }} disabled={this.state.deleteShareDisable} className="btn btn-sm "><small>DELETE</small></button>                                                
                                                            <button onClick={() => this.setState({ shareModalState: true })} style={{ backgroundColor: '#FCD095' }} className="btn btn-sm "><small>SHARE</small></button>
                                                        </React.Fragment>
                                                    }
                                                    {
                                                        this.state.shareModalState === true &&
                                                        <ModalComponent
                                                            showModal={this.state.shareModalState}
                                                            heading="Add Share"
                                                            // toggleEntireModal={this.toggleEntireTeamModal.bind(this)}
                                                            formData={addShare}
                                                            footerFormSubmitButton={['Add', 'Cancel']}
                                                            action={this.actionSelected.bind(this)}
                                                            toggleEntireModal={this.toggleEntireShareModal.bind(this)}
                                                        />
                                                    }
                                                    {
                                                        this.state.deleteModalState === true &&
                                                        <ModalComponent
                                                            showModal={this.state.deleteModalState}
                                                            heading="Add Team"
                                                            htmlText={`<div className = "ml-1 ml-md-3 pl-1 pl-md-3 ">
                                                                <p className="">Are you sure you want to Delete?</b></span>`}
                                                            footerNonSubmitButton={[{
                                                                'buttonName': 'Delete',
                                                            }, {
                                                                'buttonName': 'Cancel',
                                                            }]}
                                                            responseHandler={(type) => this.onClickDeleteEmailHandler(type)}
                                                        />
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Collapse>
                        }
                    </div>
                </ div>
            </div>


        );
    }
}

function mapStateToProps(state) {
    const saveModulePermissionsResponse = state.saveModulePermissionsReducer.data;
    const { getModulePermissionsLoading } = state.getModulePermissionsListReducer;
    const getModulePermissionsListError = state.getModulePermissionsListReducer.error;
    const getModulePermissionsListResponse = (!getModulePermissionsLoading && !getModulePermissionsListError) ? state.getModulePermissionsListReducer.data.data.message : '';

    const saveTeamDetailsResponse = state.saveTeamDetailsReducer.data;

    const {team_listMain_error, team_listMain_loading} = state.virtualTeamListMain;
    const team_listMain_data = (!team_listMain_error && !team_listMain_loading) ? state.virtualTeamListMain.team_listMain_data.data.team : []

         //Header Permission
         const { headPerLoading } = state.headerPermissionReducer
         const headPerLoadingError = state.headerPermissionReducer.error
         const headPerLoadingResonse = (!headPerLoading && !headPerLoadingError) ?  state.headerPermissionReducer.data : '';

         const singleValidatorResponse = state.singleValidatorReducer.data;


    return {
        saveModulePermissionsResponse,
        getModulePermissionsListResponse,
        saveTeamDetailsResponse,
        headPerLoadingResonse,
        headPerLoading,
        headPerLoadingError,
        team_listMain_data,

        singleValidatorResponse
    }
}

export default connect(mapStateToProps)(ShareTeam)


// WEBPACK FOOTER //
// ./src/_pages/Organzation/Analyze/Category/VirtualTeams/ShareTeam/index.js